import React from 'react';
import '../TextOverlay.css';

const TextOverlay = () => {
  return (
    <div className="text-overlay-video">
      <div className="text-video">
        <h2 className="title">Notre expertise</h2>
        <p className="description">
          Aux services des collectivités avec des solutions personnalisées pour répondre à vos besoins.
          Nous sommes à votre écoute pour fournir un service exceptionnel.
        </p>
      </div>
      
    </div>
  );
};

export default TextOverlay;
